import React, { useEffect, useState } from "react";
import { Dropdown, MenuProps, Tooltip } from "antd";
import { SoundOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { switchSpeakerDevice } from "../../../redux/slices/sipSlice";
import type { AppDispatch } from "../../../redux/store";
import "./index.scss"

const SpeakerSelector: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [devices, setDevices] = useState<MediaDeviceInfo[]>([]);
  const [selected, setSelected] = useState<string>("");

  useEffect(() => {
    async function loadDevices() {
      try {
        const all = await navigator.mediaDevices.enumerateDevices();
        const outputs = all.filter((d) => d.kind === "audiooutput");
        const uniqueDevices = outputs.reduce<MediaDeviceInfo[]>((acc, cur) => {
          const exists = acc.some((d) => d.groupId === cur.groupId);
          if (!exists) acc.push(cur);
          return acc;
        }, []);

        setDevices(uniqueDevices);

        if (outputs.length > 0 && !selected) {
          setSelected(outputs[0].deviceId);
        }
      } catch (err) {
        console.error("Error fetching devices:", err);
      }
    }

    loadDevices();
    navigator.mediaDevices.addEventListener("devicechange", loadDevices);
    return () => {
      navigator.mediaDevices.removeEventListener("devicechange", loadDevices);
    };
  }, []);

  const items: MenuProps["items"] = devices.map((d) => ({
    key: d.deviceId,
    label: d.label || `Device ${d.deviceId}`,
    onClick: () => {
      setSelected(d.deviceId);
      dispatch(switchSpeakerDevice(d.deviceId));
    },
  }));

  const selectedLabel =
    devices.find((d) => d.deviceId === selected)?.label || "Select speaker";

  if (devices.length <= 1) return null;

  return (
    <div className="speaker-selector-btn">
      <Dropdown menu={{ items }} placement="topRight" trigger={["click"]}>
        <Tooltip title={`Speaker: ${selectedLabel}`}>
          <SoundOutlined />
        </Tooltip>
      </Dropdown>
    </div>
  );
};

export default SpeakerSelector;
